import React from 'react';
import { getEmojiDataFromNative, Emoji } from 'emoji-mart';
import data from 'emoji-mart/data/all.json';

type Props = {
  emoji: string;
  size?: number;
};

// emoji-mart finds a native emoji by searching its whole table, and the task sidebar draws one per card each time it
// updates: saving one estimate spent about 0.4 s here. Each emoji is looked up once.
const emojiDataByNative = new Map<string, ReturnType<typeof getEmojiDataFromNative> | null>();

const emojiDataOf = (emoji: string) => {
  if (!emojiDataByNative.has(emoji)) emojiDataByNative.set(emoji, getEmojiDataFromNative(emoji, 'apple', data) || null);
  return emojiDataByNative.get(emoji);
};

const EmojiPreviewContent = ({ emoji, size = 12 }: Props) => {
  const emojiData = emojiDataOf(emoji);

  if (!emojiData) {
    // fallback: render native emoji
    return <span style={{ fontSize: size }}>{emoji}</span>;
  }

  return <Emoji emoji={emojiData.id} set="apple" size={size} skin={emojiData.skin || 1} />;
};

// Drawn again only when the emoji or its size changes, not whenever the card around it does.
export const EmojiPreview = React.memo(EmojiPreviewContent);
